import React, { useRef, useState, useEffect, Suspense, Fragment } from "react";
import ShimmerLoader from "../ShimmerLoader";

const GenderAgeDistrubtution = React.lazy(() => import("."));

function GenderAgeDistrubtutionLazyLoadWrapper(props) {
  const {GenderAgeDistrubtutionLoader,GenderAgeDistrubtutionAPICall, Fullscreen,genderage,Highcharts,genderAgeGroup,fromDate, toDate, cancerFilterVal1,
     selectedGenes, immunoFilter,citiesFilter,cancerStage,cancerStageTotal,cancerstagegraph} = props;

  const containerRef = useRef();
  const [isVisible, setIsVisible] = useState(false);   
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
            //  GenderAgeDistrubtutionAPICall();
          observer.disconnect();
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => observer.disconnect(); 
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
  return (
    <Fragment>
    <div ref={containerRef} 
    // style={{ minHeight: "500px" }}
    >
        {isVisible && (
           <Suspense fallback={<ShimmerLoader />}>
            {GenderAgeDistrubtutionLoader === true && <ShimmerLoader />}
            {GenderAgeDistrubtutionLoader === false && genderage && genderAgeGroup&&
            <GenderAgeDistrubtution
            Fullscreen={Fullscreen}
            genderage={genderage}
            Highcharts={Highcharts}
            genderAgeGroup={genderAgeGroup}
            cancerStage ={cancerStage}
            cancerstagegraph={cancerstagegraph}
             cancerStageTotal={cancerStageTotal}
            />}
          </Suspense>
        )}
      </div>
    </Fragment>
  );
}

export default GenderAgeDistrubtutionLazyLoadWrapper;
